<template>
	<div class="bgss">
		<div>
			<img src="../assets/lottery-title.png" style="width: 100%;"/>
		</div>
		<div>
			<div class="cc">
				<div style="position: relative;z-index: 2;font-size: 0;text-align: center;">
					<img class="yuanhuan" src="img/cjhuan.png" style="visibility: ;display: inline;">
				</div>
						
				<section id="turntable" class="gb-turntable">
					<div class="gb-turntable-container">
						<canvas class="gb-turntable-canvas" style="width: 60vw;height: 60vw;margin-top: 10vw;">抱歉！浏览器不支持。</canvas>
					</div>
					<!-- <div>抽奖</div> -->
					<img class="gb-turntable-btn" src="img/cjanniu.png" />
					<!-- <a class="gb-turntable-btn" href="javascript:;">抽奖</a> -->
				</section>
						
			</div>
			<div style="margin-top: 30px;font-size: 1.5rem;">剩余抽奖机会{{cjnum}}次</div>
			<div style="text-align: center;margin-top: 30px;">
				<img @click="dwjp" src="../assets/wdjp.png" style="width: 50%;"/>
			</div>
			<div style="text-align: center;margin-top: 20px;">
				<img @click="back" src="../assets/back-button.png" style="width: 50%;"/>
			</div>
		</div>
		<!-- -->
		<div v-if="zj_flag"  class="wdjpbg">
			<div style="position: absolute;top: 50%;left: 0;transform: translateY(-50%);width: 100%;">
				<div style="width: 80%;box-sizing: border-box;padding: 30px 25px 30px;text-align: center;background-color: #fff;border-radius: 20px;margin: 0 auto;">
					<img src="../assets/winner-title.png" style="width: 55%;position: absolute;top: 0;left: 0;transform: translateY(-50%);"/>
					<div style="color: #f32a05;font-size: 1.4rem;font-weight: bold;">恭喜中奖 您的奖品为</div>
					<div style="color: #f32a05;font-size: 1.4rem;font-weight: bold;margin-top: 10px;">{{title}}</div>
					<div style="font-size: 1.4rem;font-weight: bold;margin-top: 13px;background-color: #d9d9d9;height: 40px;line-height: 40px;">{{redemptioncode}}</div>
					<div>
						<img src="../assets/winner-qr.png" style="width: 100%;margin-top: 30px;"/>
					</div>
				</div>
				<div style="text-align: center;">
					<img @click="zj_flag=false" src="../assets/fanhui.png" style="width: 40%;margin-top: 25px;"/>
				</div>
			</div>
		</div>
		<div v-if="wd_flag"  class="wdjpbg">
			<div style="height: 50px;"></div>
			<div style="position: relative;">
				
				<div style="width: 80%;box-sizing: border-box;padding: 40px 0px 30px;text-align: center;background-color: #fff;border-radius: 20px;margin: 0 auto;position: relative;height: calc(100vh - 160px);overflow-y: auto;">
					<div style="display: flex;font-size: 1.35rem;font-weight: bold;">
						<div style="width: 50%;text-align: center;">奖项</div>
						<div style="width: 50%;text-align: center;">兑换码</div>
					</div>
					<div v-for="(item,index) in jpList" style="display: flex;font-size: 1.1rem;margin-top: 15px;">
						<div style="width: 50%;text-align: center;">{{item.title}}</div>
						<div style="width: 50%;text-align: center;">{{item.redemptioncode}}</div>
					</div>
				</div>
				<img src="../assets/wd.png" style="width: 55%;position: absolute;top: 0;left: 0;transform: translateY(-50%);"/>
				
			</div>
			
			<div style="text-align: center;">
				<img @click="wd_flag=false" src="../assets/fanhui.png" style="width: 40%;margin-top: 25px;"/>
			</div>
		</div>
		<div v-if="wzj_flag" class="wdjpbg">
			<div style="position: absolute;top: 50%;left: 0;transform: translateY(-50%);width: 100%;">
				<img src="../assets/no-win.png" style="width: 100%;"/>
				<div>
					<img @click="wzj_flag=false" src="../assets/fanhui.png" style="width: 40%;margin-top: 25px;"/>
				</div>
			</div>
		</div>
		<div v-if="loading_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
			<img src="../assets/loading.gif" style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
	</div>
</template>

<script>
	
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	Vue.use(Toast);
	export default {
		name: 'Lottery',
		components: {

		},
		data() {
			return {
				
				
				loading_flag:false,
				cj_flag:false,
				zj_flag:false,
				wzj_flag:false,
				wd_flag:false,
				cjnum:0,
				cjmsg:[],
				
				
				jpList:[],
				
				redemptioncode:null,
				title:null
				
			}
		},

		methods: {
			back(){
				this.$router.back()
			},
			dwjp(){
				let post = {
					"jytoken": window.tokenss
				}
				post = JSON.stringify(post)
				this.$api.get('/formal_myprize.php', {
					params: {
						message: post
					}
				}).then((data) => {
					if(data.data.code==1){
						this.jpList = data.data.data
						if(this.jpList.length==0){
							Toast('暂无奖品')
						}else{
							this.wd_flag = true
						}
					}else{
						Toast(data.data.data)
					}
					
				})
			},
			showCj(){
				let that = this
				var prizes = this.cjmsg;
				// var prizes = [{
				// 	text: '谢谢参与'
				// }, {
				// 	text: '光影河博通用票'
				// },{
				// 	text: '谢谢参与'
				// }, {
				// 	text: '谢谢参与'
				// }];
				var prizeid, title, jyuser_id
				gbTurntable.init({
					id: 'turntable',
					config: function(callback) {
						// 获取奖品信息
						// callback && callback(['11元红包','2元红包','3元红包','4元红包','5元红包','6元红包']);
						callback && callback(prizes);
					},
					getPrize: function(callback) {
						// 获取中奖信息
						// var num = Math.random() * prizes.length >>> 0, //奖品ID
						// 	chances = num; // 可抽奖次数
						
						let post = {
							"jytoken": window.tokenss
						}
						post = JSON.stringify(post)
						$.ajax({
							type: "get",
							url: "https://appapi.hebei.com.cn/api/2026ljytzdshd/api/formal_turntable.php",
							datatype: "json",
							data: {
								message: post
							},
							beforeSend: function() {
								that.loading_flag = true
							},
							complete: function() {
								that.loading_flag = false
							},
							//成功返回之后调用的函数
							success: function(data) {
								console.log("success:",data)
								data = JSON.parse(data)
								
								if (data.code + '' == '1') {
									
									if (that.cjnum==0) {
										window.times_out_flag = true;
									}
									that.cjnum--
									callback && callback([data.data.prizeid, that.cjnum]);
									prizeid = data.data.prizeid;
									title = data.data.title;
									that.title = data.data.title
									that.redemptioncode = data.data.redemptioncode
								} else {
									window.choujiangflag = true;
									Toast(data.msg);
									
								}
							},
							error: function(data) {
								window.choujiangflag = true;
							}
						})
						
						
					},
					gotBack: function(data) {
						// alert('恭喜抽中' + data);
						console.log("gotBack:",data)
						if (data.prizeid == 4) {
							that.wzj_flag = true
						} else {
							that.zj_flag = true
						}
						window.choujiangflag = true;
					}
				});
			}
		},
		mounted() {
			window.Toast = Toast
			
			let post = {
				"jytoken": window.tokenss
			}
			post = JSON.stringify(post)
			this.$api.get('/formal_dwcj.php', {
				params: {
					message: post
				}
			}).then((data) => {
				if(data.data.code==1){
					this.cjnum=data.data.data.cjnum
					this.cjmsg = data.data.data.cjmsg
					if(this.cjnum==0){
						window.times_out_flag = true;
					}
					this.showCj()
				}else{
					Toast(data.data.data)
				}
				
			})
		}
	}
</script>

<style scoped>
	.bgss {
		position: relative;
		background-image: url('../assets/lottery-bg.png');
		background-size: 100% 100%;
		text-align: center;
		min-height: 100vh;
	}
	.wdjpbg{
		position: fixed;
		top: 0;left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 99;
	}
</style>